import React from 'react';
import * as S from './style';
import {Text} from '../../Atom';
import {colorPalette} from '../../../config';

const ContentTitle = ({
	text,
	border,
	description,
	bgColor,
	height,
	textAlign,
}) => {
	return (
		<S.Container>
			<S.Border
				border={border ? true : false}
				bgColor={colorPalette.accent}
				height={height}
			/>
			<S.TitleWrapper
				border={border}
				textAlign={textAlign}
				style={{marginTop: '1rem'}}
			>
				<Text {...text} color={colorPalette.accent} />
				{description && <Text {...description} />}
			</S.TitleWrapper>
		</S.Container>
	);
};

export default ContentTitle;
